import { useMemo } from 'react';
import { collection } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';

import { FIRESTORE } from 'src/lib/firebase';

export function useCollectionData<T>({
  collectionName,
  query,
  enabled = true,
}: {
  query?: any;
  collectionName: string;
  enabled?: boolean;
}) {
  const q = useMemo(() => {
    if (query) {
      return query;
    }

    return collection(FIRESTORE, collectionName);
  }, [collectionName, query]);

  const [value, loading, error] = useCollection(enabled ? q : null, {
    snapshotListenOptions: { includeMetadataChanges: true },
  });

  const data = useMemo<T[]>(() => {
    if (loading) {
      return [];
    }

    return value?.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    })) as T[];
  }, [loading, value]);

  return { data, loading, error };
}
